import { createSelector } from '@ngrx/store';

import { uiStateSelector } from '../../../lib/ui-manager/ui-manager.state';
import { betslipSelector } from '../../base/store/selectors';
import { IBetslipState } from '../../base/store/state';
import { selectAllCurrentErrors } from '../validation/selectors';
import { BetslipNotificationMessageType, IBetslipNotificationState } from './state';

export const notificationSelector = createSelector(betslipSelector, (betslipState: IBetslipState): IBetslipNotificationState => {
    return betslipState.notifications;
});

export const selectBetBuilderNotification = createSelector(notificationSelector, (notification: IBetslipNotificationState): string | null => {
    return notification.messageType === BetslipNotificationMessageType.BetBuilder ||
        notification.messageType === BetslipNotificationMessageType.NotSet
        ? notification.message
        : null;
});

export const selectNotificationErrorState = createSelector(
    notificationSelector,
    uiStateSelector,
    selectAllCurrentErrors,
    (notifications, ui, errors) => ({
        notifications,
        ui,
        errors,
    }),
);
